import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import {
  EIntegrationStatus,
  TCustomField,
} from 'src/app/project/modules/custom-fields/custom-fields.model';
import { ECustomFieldType } from 'src/app/project/modules/custom-fields/custom-field-types-enums';

export type TCustomFieldMaterialIcon =
  | 'calendarToday'
  | 'checkBox'
  | 'checklist'
  | 'formatListBulleted'
  | 'formatParagraph'
  | 'functions'
  | 'looksOne'
  | 'payments'
  | 'percent'
  | 'schedule'
  | 'textFields'
  | 'viewTimeline'
  | 'edit';

const DEFAULT_MATERIAL_ICON: TCustomFieldMaterialIcon = 'textFields';

const customFieldTypeMaterialIcon: Record<ECustomFieldType, TCustomFieldMaterialIcon> = {
  [ECustomFieldType.TEXT]: 'textFields',
  [ECustomFieldType.DATE]: 'calendarToday',
  [ECustomFieldType.COST]: 'payments',
  [ECustomFieldType.LIST]: 'formatListBulleted',
  [ECustomFieldType.NUMBERS]: 'looksOne',
  [ECustomFieldType.RICHTEXT]: 'formatParagraph',
  [ECustomFieldType.TIME]: 'schedule',
  [ECustomFieldType.PERCENTAGE]: 'percent',
  [ECustomFieldType.FORMULA]: 'functions',
  [ECustomFieldType.CHECKBOX]: 'checkBox',
  [ECustomFieldType.TIMELINE]: 'viewTimeline',
  [ECustomFieldType.MULTI_LIST]: 'checklist',
  [ECustomFieldType.SIGNATURE]: 'edit',
};

const volyIntegrationIconPath: Record<EIntegrationStatus, EIconPath | null> = {
  [EIntegrationStatus.ON]: EIconPath.ICON_INTEGRATION_VOLY_ACTIVE_BIG,
  [EIntegrationStatus.DISABLED]: EIconPath.ICON_INTEGRATION_VOLY_INACTIVE_BIG,
  [EIntegrationStatus.OFF]: null,
};

const customFieldTypeLabel: Record<ECustomFieldType, string> = {
  [ECustomFieldType.TEXT]: 'Text',
  [ECustomFieldType.DATE]: 'Date',
  [ECustomFieldType.COST]: 'Cost',
  [ECustomFieldType.LIST]: 'List',
  [ECustomFieldType.NUMBERS]: 'Numbers',
  [ECustomFieldType.RICHTEXT]: 'Rich Text',
  [ECustomFieldType.TIME]: 'Time',
  [ECustomFieldType.PERCENTAGE]: 'Percentage',
  [ECustomFieldType.FORMULA]: 'Formula',
  [ECustomFieldType.CHECKBOX]: 'Checkbox',
  [ECustomFieldType.TIMELINE]: 'Timeline',
  [ECustomFieldType.MULTI_LIST]: 'Multi-Select List',
  [ECustomFieldType.SIGNATURE]: 'Digital Signature',
};

const volyIntegrationLabel: Record<EIntegrationStatus, string> = {
  [EIntegrationStatus.ON]: 'Voly Dynamic',
  [EIntegrationStatus.DISABLED]: 'Voly Dynamic',
  [EIntegrationStatus.OFF]: '',
};

export const getCustomFieldIconPath = (field: TCustomField): EIconPath | null =>
  volyIntegrationIconPath[field.volyIntegrationActive] ?? null;

export const getCustomFieldMaterialIcon = (
  field: TCustomField,
): TCustomFieldMaterialIcon | null => {
  switch (field.volyIntegrationActive) {
    case EIntegrationStatus.ON:
    case EIntegrationStatus.DISABLED:
      return null;
    case EIntegrationStatus.OFF:
      return customFieldTypeMaterialIcon[field.type];
    default:
      return DEFAULT_MATERIAL_ICON;
  }
};

export const getCustomFieldTypeLabel = (field: TCustomField): string =>
  volyIntegrationLabel[field.volyIntegrationActive] || customFieldTypeLabel[field.type];
